export default __webpack_public_path__ + "static/media/Maxdol-60-mg-IM-ban.d66bc40a.jpg";